export default "__VITE_ASSET__d23d8982__"